if ( typeof ProductBundler !== 'function' ) {

  class ProductBundler extends HTMLElement {

    constructor() {

      super();

      if ( this.querySelector('css-slider') ) {
        this.querySelector('css-slider').addEventListener('ready', ()=>{
          this.init();
        })
      } else {
        this.init();
      }

    }

    initBundler() {

      this._bundleMin = parseInt(this.dataset.minimum);
      this._bundleTemplate = this.querySelector('[data-js-bundler-product]').cloneNode(true);

      this.querySelectorAll('[data-js-bundler-product-remove]').forEach(elm=>{
        elm.addEventListener('click', e=>{
          this.clearSlot(e.target.closest('[data-js-bundler-product]'));
        });
      });

      this.querySelector('[data-js-bundler-toggle]').addEventListener('click', e=>{
        if ( window.innerWidth < 768 ) {
          this.classList.toggle('opened');
        }
      });

      this.querySelector('[data-js-add-bundle-to-cart]').addEventListener('click', e=>{

        if ( ! this.findEmptySlot() ) {

          let items = [];
          this.bundleProducts.map(elm=>{
            if ( elm.dataset.id ) {
              if ( ! items.find(item => {
                if ( item.id == elm.dataset.id ) {
                  item.quantity++;
                  return true;
                }
              }) ) {
                items.push({
                  id: elm.dataset.id,
                  quantity: 1
                })
              }
            }
          })

          if ( items.length > 0 ) {

            const submitButton = this.querySelector('[data-js-add-bundle-to-cart]');
            submitButton.classList.add('working');
            window.handleAddToCart(
              JSON.stringify({'items': items}), items.reduce((total, { quantity }) => total + quantity, 0),
              { 'Content-Type': 'application/json' },
              ()=>{
                submitButton.classList.remove('working');
                this.querySelectorAll('[data-js-bundler-product]').forEach(elm=>{
                  this.clearSlot(elm);
                });
                this.classList.remove('opened');

                // Aplicar el código del tier activo, después abrir el drawer (sin navegar)
                var activeTier = this.querySelector('.bundler__tier.is-active');
                var code = activeTier ? (activeTier.dataset.tierCode || '').trim() : '';

                if (code) {
                  fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ discount: code })
                  })
                  .then(function(r){ return r.json(); })
                  .catch(function(err){ console.warn('[bundler] no se pudo aplicar el código:', err); })
                  .finally(()=>{ this.openCartDrawer(); });
                } else {
                  this.openCartDrawer();
                }
              }
            );

          }

        }

      });

      // Texto dinámico del botón según el estado del bundle.
      // Cuando el bundle está completo (clase bundler-full en el host) → "Agregar al carrito"
      // Cuando todavía faltan productos → "Seleccionar productos"
      this.initAddToCartButtonText();

    }

    initAddToCartButtonText() {
      const buttonTextSpan = this.querySelector('[data-js-add-bundle-to-cart] .button__text');
      if (!buttonTextSpan) return;

      // Guardamos el texto original (viene del Liquid: "Agregar al carrito") como label "completo"
      this._addToCartLabelFull = (buttonTextSpan.textContent || '').trim() || 'Agregar al carrito';
      this._addToCartLabelEmpty = 'Seleccionar productos';

      // Setear el texto inicial según el estado actual
      this.updateAddToCartButtonText();

      // Observer para reaccionar a cambios en la clase del host (bundler-full / no full)
      const observer = new MutationObserver(() => {
        this.updateAddToCartButtonText();
      });
      observer.observe(this, { attributes: true, attributeFilter: ['class'] });
    }

    updateAddToCartButtonText() {
      const buttonTextSpan = this.querySelector('[data-js-add-bundle-to-cart] .button__text');
      if (!buttonTextSpan) return;

      const label = this.classList.contains('bundler-full')
        ? this._addToCartLabelFull
        : this._addToCartLabelEmpty;

      if (buttonTextSpan.textContent.trim() !== label) {
        buttonTextSpan.textContent = label;
      }
    }


    openCartDrawer() {
      // El theme decide entre popup o drawer dentro de handleAddToCart según
      // KROWN.settings.cart_popup. En este store está configurado para popup,
      // entonces forzamos el comportamiento: cerramos el popup y refrescamos el carrito.
      setTimeout(() => {
        // 1) Cerrar el mini-cart-popup (recuadro verde con checkmark)
        const miniCartPopup = document.getElementById('mini-cart-popup');
        if (miniCartPopup && typeof miniCartPopup.hide === 'function') {
          miniCartPopup.hide();
        }

        // 2) Refrescar el contenido del carrito para reflejar el descuento recién
        //    aplicado y abrir el sidebar. refreshCart() re-fetchea helper-cart
        //    (que trae el total ya con el descuento) y hace .show() del sidebar.
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          const cartSidebar = document.getElementById('site-cart-sidebar');
          if (cartSidebar && typeof cartSidebar.show === 'function') {
            cartSidebar.show();
          }
        }
      }, 50);
    }

    initProducts() {

      this.bundleProducts = [...this.querySelectorAll('[data-js-bundler-product]')];

      this.querySelectorAll('[data-js-product-add-to-cart]').forEach(elm=>{
        if ( ! elm.hasAttribute('data-init') ) {

          elm.addEventListener('click', e=>{
            e.preventDefault();
            const product = e.target.closest('[data-js-product-item]');
            product.querySelector('.button__text').innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
            const variant = product.querySelector('product-variants').currentVariant;
            this.addToBundle(variant, product);
            this.classList.add('opened');
          });
          elm.setAttribute('data-init', '');

          elm.closest('.product-item').addEventListener('reload', e=>{
            this.initProducts();
          });

        }
      });

      // Quick view: interceptar clicks en los links del producto para abrir el modal
      // en lugar de navegar a la página de producto.
      this.initQuickView();

    }

    initQuickView() {
      if (!this._quickViewModals) {
        this._quickViewModals = {};
      }

      this.querySelectorAll('[data-js-product-item]').forEach(productItem => {
        if (productItem.hasAttribute('data-quick-view-init')) return;

        const productLinks = productItem.querySelectorAll('a[href*="/products/"]');
        if (productLinks.length === 0) return;

        productLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            // No interceptar si está dentro del botón "agregar al bundle"
            if (e.target.closest('[data-js-product-add-to-cart]')) return;
            e.preventDefault();
            e.stopPropagation();
            this.openQuickView(link.getAttribute('href'), productItem);
          });
        });

        productItem.setAttribute('data-quick-view-init', '');
      });
    }

    openQuickView(href, productItem) {
      // Normalizamos la URL para usarla como key del caché
      const productUrl = href.split('?')[0];

      // Si ya tenemos el modal cacheado, lo abrimos directamente
      if (this._quickViewModals[productUrl]) {
        // Actualizamos la referencia al product-item original (por si se reabre desde otro)
        this._quickViewModals[productUrl]._productItem = productItem;
        this._quickViewModals[productUrl].show();
        return;
      }

      productItem.classList.add('working');
      const productId = productItem.id || `bundle-qv-${Date.now()}`;

      fetch(`${href}${href.includes('?') ? '&' : '?'}view=quick-view`)
        .then(response => response.text())
        .then(text => {
          const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

          if (!quickViewHTML) {
            console.warn('[bundler-quickview] No se encontró #product-quick-view, redirigiendo a la página del producto');
            productItem.classList.remove('working');
            window.location.href = href;
            return;
          }

          const quickViewContainer = document.createElement('div');
          quickViewContainer.innerHTML = `<modal-box id="modal-qv-${productId}"
            class="modal modal--product"
            data-options='{
              "enabled": false,
              "showOnce": false,
              "blockTabNavigation": true
            }'
            tabindex="-1" role="dialog" aria-modal="true"
          >
            <div class="container--medium">
              <div class="modal-content" data-js-product-page>
                <button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
              </div>
            </div>
            <span class="modal-background" data-js-close></span>
          </modal-box>`;

          const quickViewModal = quickViewContainer.querySelector('modal-box');
          quickViewModal.classList.add('modal--bundler-quickview');
          document.body.appendChild(quickViewModal);
          quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

          this._quickViewModals[productUrl] = quickViewModal;
          quickViewModal._productItem = productItem;

          setTimeout(() => {
            this.initQuickViewModal(quickViewModal);
          }, 100);

          quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', () => {
            this.initQuickViewModal(quickViewModal);
          });

          // Inyectar los scripts del product page (solo la primera vez)
          if (!window.productPageScripts) {
            const scripts = quickViewModal.querySelectorAll('script');
            scripts.forEach(elm => {
              const script = document.createElement('script');
              script.src = elm.src;
              document.body.append(script);
              window.productPageScripts = true;
            });
          }

          setTimeout(() => {
            quickViewModal.show();
            productItem.classList.remove('working');
          }, 250);
        })
        .catch(err => {
          console.error('[bundler-quickview] Error al cargar quick view:', err);
          productItem.classList.remove('working');
          window.location.href = href;
        });
    }

    initQuickViewModal(modal) {
      const closeBtn = modal.querySelector('.product-quick-view__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          modal.hide();
        });
      }

      // Reemplazamos el botón de "agregar al carrito" por "agregar al bundle"
      this.swapAddToCartForAddToBundle(modal);

      const productVariants = modal.querySelector('product-variants');
      if (productVariants && !productVariants._defaultToFirstVariant) {
        productVariants.querySelectorAll('.product-variant__item--color [data-product-url][data-selected]').forEach(elm => {
          if (!elm.hasAttribute('data-silent-selected')) {
            elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
          }
        });
        if (parseInt(productVariants.dataset.variants) == 1) {
          productVariants.updateBuyButtons();
        }
      }
    }

    swapAddToCartForAddToBundle(modal) {
      const productForm = modal.querySelector('[data-js-product-form]') || modal.querySelector('form[action*="/cart/add"]');
      if (!productForm) return;

      // Forzamos quantity = 1 (el bundle agrega de a uno)
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      if (quantityInput) quantityInput.value = '1';

      const submitButton = productForm.querySelector('[type="submit"]');
      if (!submitButton) return;

      // 1) Cambiar el texto del botón a "Agregar al bundle"
      const bundleLabel = (KROWN && KROWN.settings && KROWN.settings.locales && KROWN.settings.locales.products_add_to_bundle_button)
        ? KROWN.settings.locales.products_add_to_bundle_button
        : 'Agregar al bundle';

      const buttonTextSpan = submitButton.querySelector('.button__text');
      if (buttonTextSpan) {
        buttonTextSpan.textContent = bundleLabel;
      } else {
        submitButton.textContent = bundleLabel;
      }

      // 2) Reemplazar el botón por un clon para limpiar los listeners del theme
      //    (product-form custom element o cualquier otro handler de add-to-cart)
      const newButton = submitButton.cloneNode(true);
      newButton.type = 'button';
      submitButton.replaceWith(newButton);

      // 3) Al clickear, agregar al bundle y cerrar el modal
      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const originalProductItem = modal._productItem;
        const productVariantsInModal = modal.querySelector('product-variants');
        const variant = productVariantsInModal ? productVariantsInModal.currentVariant : null;

        if (!originalProductItem) {
          console.warn('[bundler-quickview] No hay referencia al product-item original');
          return;
        }
        if (!variant) {
          console.warn('[bundler-quickview] No se pudo leer la variant seleccionada en el modal');
          return;
        }

        // Sincronizar el input[name="id"] del product-item original con la variant elegida
        const idInput = originalProductItem.querySelector('input[name="id"]');
        if (idInput) idInput.value = variant.id;

        // Actualizar el texto del botón en la card del producto (visual feedback)
        const originalBtnText = originalProductItem.querySelector('[data-js-product-add-to-cart] .button__text');
        if (originalBtnText && KROWN.settings.locales.products_added_to_bundle_label) {
          originalBtnText.innerHTML = KROWN.settings.locales.products_added_to_bundle_label;
        }

        // Agregar al bundle y cerrar el modal
        this.addToBundle(variant, originalProductItem);
        this.classList.add('opened');
        modal.hide();
      });
    }

    init() {
      this.initBundler();
      this.initProducts();
    }

    findEmptySlot() {
      return this.bundleProducts.find(elm=>{
        return elm.classList.contains('bundler-product--empty')
      });
    }

    clearSlot(slot) {
      slot.product.querySelector('[data-js-product-add-to-cart-text]').textContent = KROWN.settings.locales.products_add_to_bundle_button;
      if ( this.bundleProducts.length > this._bundleMin ) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        slot.product.classList.remove('product-item--bundled');
        slot.remove();
      } else {
        slot.product.classList.remove('product-item--bundled');
        slot.dataset.id = "";
        slot.dataset.variant = null;
        slot.dataset.productPrice = "";
        slot.product = null;
        slot.classList.add('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = '';
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = '';
      }
      this.updateBundlerFullState();
      this.reorderSlots();
    }

    reorderSlots() {
      let ei = 0,
          fi = -100;
      this.querySelectorAll('[data-js-bundler-product]').forEach((elm, i)=>{
        if ( elm.classList.contains('bundler-product--empty') ) {
          elm.style.order = ei++;
        } else {
          elm.style.order = fi++;
        }
      });
    }

    createSlot(){
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot.querySelector('[data-js-bundler-product-remove]').addEventListener('click', e=>{
        this.clearSlot(e.target.closest('[data-js-bundler-product]'));
      });
      this.querySelector('[data-js-bundler-products]').appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {

      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image ? variant.featured_image.src : product.querySelector('[data-js-quick-buy-product-image]').textContent;

      if ( ! slot && this.hasAttribute('data-limit-maximum') ) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if ( slot ) {

        slot.classList.remove('bundler-product--empty');
        slot.querySelector('[data-js-bundler-product-text]').innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${product.querySelector('[data-js-quick-buy-product-title]').textContent}</span>
          ${ product.querySelector('product-variants').hasAttribute('data-has-variants') ? `<span class="bundler-product__text-variant text-color--opacity">${variant.title}</span>` : '' }
        `;
        slot.querySelector('[data-js-bundler-product-image]').innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 240)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 160)} 160w,
              ${this.getResizedImageSrc(imageSrc, 240)} 240w,
              ${this.getResizedImageSrc(imageSrc, 360)} 360w,
              ${this.getResizedImageSrc(imageSrc, 480)} 480w
            "
            sizes="(max-width: 767px) 25vw, 200px"
          />
        `;

        if ( this.hasAttribute('data-limit-bundles') ) {
          product.classList.add('product-item--bundled');
        }
        slot.product = product;
        slot.dataset.id = product.querySelector('input[name="id"]').value;
        slot.dataset.variant = product.querySelector('product-variants').currentVariant;
        slot.dataset.productPrice = variant.price;

      } else {
        // when bundle is full, show message
      }

      this.updateBundlerFullState();

    }

    updateBundlerFullState() {
      // Modo "X o más" (data-limit-maximum):
      //  - Siempre garantizamos un slot vacío extra para poder seguir agregando
      //  - El bundle se considera "completo" si hay al menos _bundleMin productos llenos
      // Modo normal:
      //  - El bundle es "completo" cuando no quedan slots vacíos
      if (this.hasAttribute('data-limit-maximum')) {
        if (!this.findEmptySlot()) {
          this.createSlot();
          this.reorderSlots();
        }
        const filledCount = this.querySelectorAll('[data-js-bundler-product]:not(.bundler-product--empty)').length;
        if (filledCount >= this._bundleMin) {
          this.classList.add('bundler-full');
        } else {
          this.classList.remove('bundler-full');
        }
      } else {
        if (!this.findEmptySlot()) {
          this.classList.add('bundler-full');
        } else {
          this.classList.remove('bundler-full');
        }
      }
    }

    getResizedImageSrc(src, size, crop='center') {
      return (`${src}${src.includes('?') ? '&' : '?'}width=${size}&height=${size}&crop=${crop}`).replace(/\n|\r|\s/g, "");
    }

  }

  if ( typeof customElements.get('product-bundler') == 'undefined' ) {
    customElements.define('product-bundler', ProductBundler);
  }

}